import type { ComponentProps } from 'react';
import { cx } from '@/styled-system/css';
import { skeletonBlock } from './skeletonBlock.styles';

type SkeletonBlockProps = ComponentProps<'span'> & {
  /** Corner rounding; use `md` to sit flush with card surfaces. */
  radius?: 'sm' | 'md';
};

export function SkeletonBlock({ className, radius, ...props }: SkeletonBlockProps) {
  return <span {...props} aria-hidden="true" className={cx(skeletonBlock({ radius }), className)} />;
}
